import { createSelector } from "reselect";

export const getPaymentTypeSelector = (state) => {
  if (state.object) {
    return state.object.payment_type
  }
}

export const getPrioritySelector = (state) => {
  if (state.object.priority) {
    let priority = { ...state.object.priority, verifiedUserStatus: 1 }

    return priority
  }
}
export const getContractStageSelector = (state) => {
  if (state.object.contractStage) {
    return state.object.contractStage
  }
}

export const descriptionSelector = (state) => {
  if (state.object.description) {
    return state.object.description.description ? "Y" : "N"
  }

}

export const photosSelector = (state) => {
  if (state.object.photo) {
    return state.object.photo.photos.length >= 5 ? "Y" : "N"
  }

}

export const locationSelector = (state) => {
  if (state.object.location) {

    return state.object.location.distance.value.length !== 0 || state.object.location.howToGet ? "Y" : "N"

  }
}


export const contactSelector = (state) => {
  if (state.object.contact) {
    return state.object.contact.phones.length !== 0 ? "Y" : "N"
  }
}

export const servicesSelector = (state) => {
  if (state.object.services) {
    let servicesArr = Object.values(state.object.services)

    for (let service in servicesArr) {
      if (servicesArr[service].values.filter(item => item.selected).length !== 0) {
        return "Y"
      }
    }
    return "N"
  }

}


export const rulesSelector = (state) => {
  if (state.object.rules) {
    return state.object.rules.restrictions.values.filter(item => item.selected).length !== 0 ? "Y" : "N"
  }
}

export const hasRoomsSelector = (state) => {
  if (state.object.rooms) {
    return !state.object.rooms.length ? "N" : "Y"
  }
}

export const hasActiveRoomSelector = (state) => {
  if (state.object.rooms) {
    return state.object.rooms.filter(item => item.active === "Y").length !== 0 ? "Y" : "N"
  }
}

export const getVerifiedUserStatusSelector = (state) => {
  return state.user.verified
}

export const disabledRoomSelector = (state) => {
  if (state.object.rooms) {
    return state.object.rooms.filter(item => item.active === "N")[0]
  }
}

export const hasDisabledRoomSelector = createSelector(
  disabledRoomSelector,
  (disabledRoom) => !disabledRoom ? "Y" : "N"
)


export const progressItemsSelector = createSelector(
  descriptionSelector, photosSelector, locationSelector, contactSelector,
  servicesSelector, rulesSelector, hasRoomsSelector,
  hasDisabledRoomSelector, getVerifiedUserStatusSelector,
  (description, photos, location, contact, services, rules, activeRoom, disabledRoom, verifiedUserStatus) => {

    return {
      description,
      photo: photos,
      location,
      contact,
      services,
      rules,
      activeRoom,
      disabledRoom,
      verifiedUserStatus
    }
  })


export const progressSelector = createSelector(progressItemsSelector, (progressItems) => {

  let progressInPercent = Object.values(progressItems).filter(item => item === "Y").length * 11


  return progressInPercent === 99 ? progressInPercent + 1 : progressInPercent
})


export const progressItemsHasProblemSelector = createSelector(
  progressItemsSelector,
  disabledRoomSelector,
  hasRoomsSelector,
  getPrioritySelector,
  getPaymentTypeSelector,
  getVerifiedUserStatusSelector,
  (
    progressItems,
    disabledRoom,
    hasRooms,
    priority,
    paymentType,
    verifiedUserStatus
  ) => {
    let progressItemsHasProblem = []
    Object.keys(progressItems).map(item => {
      if (progressItems[item] === "N" && item !== "disabledRoom" && item !== "activeRoom") {
        progressItemsHasProblem.push(item)
      }
    })

    if (hasRooms && disabledRoom && disabledRoom.photos && disabledRoom.photos < 3) {
      progressItemsHasProblem.push("roomPhotos")
    }
    if (hasRooms && disabledRoom && !disabledRoom.availability && paymentType === "percent") {
      progressItemsHasProblem.push("availability")
    }

    if (hasRooms && disabledRoom && !disabledRoom.prices) {
      progressItemsHasProblem.push("prices")
    }

    const priporityMap = (num) => (priority && priority[num]) ? priority[num] : hasRooms !== "N" ? 1 : 3

    progressItemsHasProblem.sort((a, b) => priporityMap(a) - priporityMap(b))

    if (hasRooms === "N") {
      progressItemsHasProblem.unshift("activeRoom")
    }

    return progressItemsHasProblem
  })


export const getHasActiveContractBtnSelector = createSelector(getContractStageSelector, getPrioritySelector, progressItemsHasProblemSelector, hasActiveRoomSelector, (contractStage, priority, itemsHasProblem, hasActiveRoom) => {
  let priorityRoom = hasActiveRoom === "N" ? 1 : 3
  const fullPriority = {
    ...priority,
    activeRoom: priorityRoom,
    availability: priorityRoom,
    prices: priorityRoom,
    roomPhotos: priorityRoom
  }

  return contractStage && contractStage !== 'concluded' && fullPriority[itemsHasProblem[0]] !== 1
})






